const ADJUST_FOLLOWING_COUNT = 'PROFILE_USER_STATS_ADJUST_FOLLOWING_COUNT'

function adjustFollowingCount(amount) {
  return {
    type: ADJUST_FOLLOWING_COUNT,
    payload: { amount }
  }
}

module.exports = {
  ADJUST_FOLLOWING_COUNT,
  adjustFollowingCount
}
